import React, { useState, useEffect, Dispatch, SetStateAction } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { commonString } from "../../../../AdminApi/commFunc";
import { useApi } from "../../../../hooks/useApi";
import ConfirmBtn from "../../../Button/ConfirmBtn";
import LineBtn from "../../../Button/LineBtn";
import FilterIcon from "../../../DefaultStyles/FilterIcon";
import Loader from "../../../DefaultStyles/Loader";
import DropDown, { OptionType } from "../../../Filters/DropDown";
import FaqCategoryDeleteModal from "../../Manage/ManageFaq/FagCategory/FaqCategoryDeleteModal";
import FaqCategoryModal from "../../Manage/ManageFaq/FagCategory/FaqCategoryModal";
import { FilterFlex } from "../../Manage/TempAccount/TempAccountHistory/TempAccountHistoryFilter";
import { PartyInfoFilterContainer } from "../../Party/PartyInfo/PartyInfoFilter";

interface NoticeFilterProps {
  setFilter: Dispatch<
    SetStateAction<{
      categoryId: number;
      orderByViewCount: string;
      ispublic: number;
      isTop: number;
    }>
  >;
}

export default function NoticeFilter({ setFilter }: NoticeFilterProps) {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const isNotice = pathname?.includes("notice");

  const [addCategoryModal, setAddCategoryModal] = useState(false);
  const [deleteCategoryModal, setDeleteCategoryModal] = useState(false);
  const [categoryType, setCategoryType] = useState({
    value: "",
    label: "선택",
  });
  const [category, setCategory] = useState<OptionType>({
    value: "",
    label: "선택",
  });
  const [categoryBoxClick, setCategoryBoxClick] = useState(false);
  const [categoryList, setCategoryList] = useState<OptionType[]>([]);

  const termsCategoryTypeOption = [
    { value: "category", label: "카테고리" },
    { value: "show", label: "공개 여부" },
  ];

  const noticeCategoryTypeOption = [
    ...termsCategoryTypeOption,
    { value: "top", label: "상단 고정 여부" },
  ];

  const termsShowOption = [
    { value: "1", label: "공개" },
    { value: "0", label: "비공개" },
  ];

  const noticeTopOption = [
    { value: "1", label: "상단 고정" },
    { value: "0", label: "고정 x" },
  ];

  // 카테고리 리스트
  const { response, loading } = useApi({
    method: "get",
    url: categoryBoxClick
      ? `category?type=${commonString(pathname).type}`
      : undefined,
  });

  useEffect(() => {
    if (response?.status === 200) {
      const serverList: { id: string; name: string }[] = response?.data;

      let dropdownList = [];

      for (let i = 0; i < serverList.length; i++) {
        const el = serverList[i];

        dropdownList.push({
          value: `${el.id}`,
          label: `${el.name}`,
        });
      }

      if (response?.status === 200) {
        setCategoryList(dropdownList);
      }
    }
  }, [response]);

  useEffect(() => {
    setCategoryType({
      value: "",
      label: "선택",
    });
    setCategory({
      value: "",
      label: "카테고리 선택",
    });
    setFilter((prev) => ({
      orderByViewCount: "id",
      categoryId: 0,
      ispublic: 2,
      isTop: 2,
    }));
  }, [pathname]);

  return (
    <>
      <PartyInfoFilterContainer maxWidth={1000}>
        <div></div>

        <div>
          <FilterFlex gapSize={10} maxWidth={1000}>
            <LineBtn
              icon="add"
              btnText={`${commonString(pathname).title} 추가`}
              sPadding="0 12px 0 10px"
              btnHeight={38}
              btnClickEvent={() =>
                navigate(`/linkid-manage/${commonString(pathname).route}/add`)
              }
            />
            <LineBtn
              icon="edit"
              btnText="카테고리 추가 및 변경"
              sPadding="0 12px 0 10px"
              btnHeight={38}
              btnClickEvent={() => setAddCategoryModal(true)}
            />
            <LineBtn
              icon="delete"
              btnText="카테고리 삭제"
              sPadding="0 12px 0 10px"
              btnHeight={38}
              btnClickEvent={() => setDeleteCategoryModal(true)}
            />
          </FilterFlex>

          <FilterFlex gapSize={10} style={{ marginBottom: 0 }} maxWidth={1000}>
            <FilterIcon maxWidth={1000} />

            {/* 카테고리 타입 */}
            <DropDown
              boxWidth={180}
              dropdownValue={categoryType}
              setDropDownValue={setCategoryType}
              optionList={
                isNotice ? noticeCategoryTypeOption : termsCategoryTypeOption
              }
            />

            {/* 카테고리 선택 */}
            <div
              onClick={() => {
                if (categoryType?.value === "category") {
                  setCategoryBoxClick(true);
                }
              }}
            >
              <DropDown
                boxWidth={180}
                dropdownValue={category}
                setDropDownValue={setCategory}
                optionList={
                  categoryType?.value === "category"
                    ? categoryList
                    : categoryType?.value === "show"
                    ? termsShowOption
                    : noticeTopOption
                }
                isDisabled={categoryType?.value === ""}
              />
            </div>

            <ConfirmBtn
              btnColor="mint"
              btnText="적용"
              btnHeight={38}
              isDisabled={category?.value === ""}
              btnClickEvent={() => {
                if (categoryType?.value === "top") {
                  setFilter((prev) => ({
                    ...prev,
                    isTop: Number(category?.value) ?? 0,
                  }));
                } else if (categoryType.value === "show") {
                  setFilter((prev) => ({
                    ...prev,
                    ispublic: Number(category?.value) ?? 0,
                  }));
                } else {
                  setFilter((prev) => ({
                    ...prev,
                    categoryId: Number(category?.value) ?? 0,
                  }));
                }
              }}
            />

            <LineBtn
              btnColor="mint"
              icon="refresh"
              btnText="초기화"
              btnHeight={38}
              disabled={category?.value === ""}
              btnClickEvent={() => {
                setCategoryType({
                  value: "",
                  label: "선택",
                });
                setCategory({
                  value: "",
                  label: "카테고리 선택",
                });
                setFilter((prev) => ({
                  ...prev,
                  categoryId: 0,
                  ispublic: 2,
                  isTop: 2,
                }));
              }}
            />

            <LineBtn
              btnText="조회순"
              icon="filter_list"
              btnHeight={38}
              sPadding={"10px 12px 10px 10px"}
              btnClickEvent={() => {
                setFilter((prev) => ({
                  ...prev,
                  orderByViewCount: "viewcount",
                }));
              }}
            />
          </FilterFlex>
        </div>
      </PartyInfoFilterContainer>

      {loading && <Loader />}

      {addCategoryModal && (
        <FaqCategoryModal closeEvent={() => setAddCategoryModal(false)} />
      )}

      {deleteCategoryModal && (
        <FaqCategoryDeleteModal
          closeEvent={() => setDeleteCategoryModal(false)}
        />
      )}
    </>
  );
}
